import { en, type MessageKey } from "./en";
import { hi } from "./hi";

export type { MessageKey };
export type Locale = "en" | "hi";

const catalogs: Record<Locale, Partial<Record<MessageKey, string>>> = { en, hi };
let locale: Locale = "en"; // English in v1

export function setLocale(l: Locale): void {
  locale = l;
}

/** Translate a key; `{name}` placeholders are filled from vars. */
export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  let s = catalogs[locale][key] ?? en[key];
  for (const [k, v] of Object.entries(vars ?? {})) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}
